module.exports = {
  "props": [
    {
      "name": "active-class",
      "type": "string",
      "default": "undefined",
      "source": "v-tabs",
      "description": {
        "en": "The **active-class** applied to children when they are activated.",
        "ja": "子要素が有効な場合、子要素に **active-class** が適用されます。",
        "zh-Hans": "**active-class** 在子组件（children ）被激活时应用。"
      }
    },
    {
      "name": "align-with-title",
      "type": "boolean",
      "default": "false",
      "source": "v-tabs",
      "description": {
        "en": "Make `v-tabs` lined up with the toolbar title",
        "ja": "`v-tabs`をツールバーのタイトルと揃えます",
        "zh-Hans": "让`v-tabs`与工具栏标题对齐"
      }
    },
    {
      "name": "background-color",
      "type": "string",
      "default": "undefined",
      "source": "v-tabs",
      "description": {
        "en": "Changes the background color of the component.",
        "ja": "コンポーネントの背景色を変更します。",
        "zh-Hans": "更改组件的背景颜色。"
      }
    },
    {
      "name": "center-active",
      "type": "boolean",
      "default": "false",
      "source": "v-tabs",
      "description": {
        "en": "Forces the selected tab to be centered",
        "ja": "選択したタブを強制的に中央に配置します",
        "zh-Hans": "强制所选标签以居中"
      }
    },
    {
      "name": "centered",
      "type": "boolean",
      "default": "false",
      "source": "v-tabs",
      "description": {
        "en": "Centers the tabs",
        "ja": "タブを中央寄せにします。",
        "zh-Hans": "将选项卡居中"
      }
    },
    {
      "name": "color",
      "type": "string",
      "default": "undefined",
      "source": "colorable",
      "description": {
        "en": "Applies specified color to the control - it can be the name of material color (for example `success` or `purple`) or css color (`#033` or `rgba(255, 0, 0, 0.5)`). You can find a list of built-in classes on the [colors page](/styles/colors#material-colors).",
        "ja": "指定された色をコントロールに適用します。利用できるのはマテリアルカラーの名前 (たとえば、`success` または ` purple`) または css 表記の色 (`#033`または` rgba(255, 0, 0, 0.5) `) です。[colors のページ](/styles/colors#material-colors) で、組み込みクラスのリストが確認できます。",
        "zh-Hans": "指定控件颜色，颜色值可以是 Material 颜色（例如 <code>success</code>或者 <code>purple</code> ）也可以是 Css 颜色 （例如 <code>#033</code> 或者 <code>rgba(255, 0, 0, 0.5)</code>）。在 [colors page](/zh-Hans/styles/colors#material-colors)中可以找到内置颜色类列表。"
      }
    },
    {
      "name": "dark",
      "type": "boolean",
      "default": "false",
      "source": "themeable",
      "description": {
        "en": "Applies the dark theme variant to the component. You can find more information on the Material Design documentation for [dark themes](https://material.io/design/color/dark-theme.html).",
        "ja": "コンポーネントにダークテーマを適応します。詳しく知りたい場合は、Material Design documentationの[dark themes](https://material.io/design/color/dark-theme.html)を参照してください。",
        "zh-Hans": "将暗色主题变量应用到组件。你可以在 [dark themes](https://material.io/design/color/dark-theme.html) 的 Material Design 文档中找到更多有关信息。"
      }
    },
    {
      "name": "fixed-tabs",
      "type": "boolean",
      "default": "false",
      "source": "v-tabs",
      "description": {
        "en": "`v-tabs-item` min-width 160px, max-width 360px",
        "ja": "`v-tabs-item` min-width 160px, max-width 360px",
        "zh-Hans": "`v-tabs-item` min-width 160px, max-width 360px"
      }
    },
    {
      "name": "grow",
      "type": "boolean",
      "default": "false",
      "source": "v-tabs",
      "description": {
        "en": "Force `v-tab`'s to take up all available space",
        "ja": "`v-tab`を強制的に利用可能なすべてのスペースに占有させます",
        "zh-Hans": "强制 `v-tab` 占用所有可用空间"
      }
    },
    {
      "name": "height",
      "type": [
        "number",
        "string"
      ],
      "default": "undefined",
      "source": "v-tabs",
      "description": {
        "en": "Sets the height of the tabs bar",
        "ja": "タブバーの高さを指定します",
        "zh-Hans": "设置标签栏高度"
      }
    },
    {
      "name": "hide-slider",
      "type": "boolean",
      "default": "false",
      "source": "v-tabs",
      "description": {
        "en": "Hide's the generated `v-tabs-slider`",
        "ja": "生成された `v-tabs-slider` を隠す",
        "zh-Hans": "隐藏生成的 `v-tabs-slider`"
      }
    },
    {
      "name": "icons-and-text",
      "type": "boolean",
      "default": "false",
      "source": "v-tabs",
      "description": {
        "en": "Will stack icon and text vertically",
        "ja": "アイコンとテキストを垂直（縦）に重ねる",
        "zh-Hans": "将堆叠图标和文字垂直"
      }
    },
    {
      "name": "light",
      "type": "boolean",
      "default": "false",
      "source": "themeable",
      "description": {
        "en": "Applies the light theme variant to the component.",
        "ja": "コンポーネントにlightテーマを適用します。",
        "zh-Hans": "为组件设置浅色主题。"
      }
    },
    {
      "name": "mobile-breakpoint",
      "type": [
        "string",
        "number"
      ],
      "default": "undefined",
      "source": "v-tabs",
      "description": {
        "en": "Sets the designated mobile breakpoint for the component.",
        "ja": "コンポーネントに指定されたモバイルのbreakpointを指定します。",
        "zh-Hans": "为组件设置和指定移动设备的屏幕尺寸断点"
      }
    },
    {
      "name": "next-icon",
      "type": "string",
      "default": "'$next'",
      "source": "v-tabs",
      "description": {
        "en": "Right pagination icon",
        "ja": "右ページネーションのアイコンを設定します。",
        "zh-Hans": "左分页图标"
      }
    },
    {
      "name": "optional",
      "type": "boolean",
      "default": "false",
      "source": "v-tabs",
      "description": {
        "en": "Does not require an active item. Useful when using `v-tab` as a `router-link`",
        "ja": "アクティブなアイテムは必要ありません。`v-tab`を`router-link`として使用する場合に便利です。",
        "zh-Hans": "不需要活动项目。 在将 `v-tab` 用作 `router-link` 时有用"
      }
    },
    {
      "name": "prev-icon",
      "type": "string",
      "default": "'$prev'",
      "source": "v-tabs",
      "description": {
        "en": "Left pagination icon",
        "ja": "左ページネーションのアイコンを設定します。",
        "zh-Hans": "右分页图标"
      }
    },
    {
      "name": "right",
      "type": "boolean",
      "default": "false",
      "source": "v-tabs",
      "description": {
        "en": "Aligns tabs to the right",
        "ja": "タブを右揃えにします。",
        "zh-Hans": "将选项向右侧对齐"
      }
    },
    {
      "name": "show-arrows",
      "type": [
        "boolean",
        "string"
      ],
      "default": "undefined",
      "source": "v-tabs",
      "description": {
        "en": "Show pagination arrows if the tab items overflow their container. For mobile devices, arrows will only display when using this prop.",
        "ja": "タブ項目がコンテナをオーバーフローした場合は、ページ番号の矢印を表示します。モバイル デバイスの場合、矢印は、このpropを使用する場合にのみ表示されます。",
        "zh-Hans": "如果选项卡项目超出其容器，则显示分页箭头。 对于移动设备，仅在使用此属性时才会显示箭头。"
      }
    },
    {
      "name": "slider-color",
      "type": "string",
      "default": "undefined",
      "source": "v-tabs",
      "description": {
        "en": "Changes the background color of an auto-generated `v-tabs-slider`",
        "ja": "自動生成された`v-tabs-slider`の背景色を変更します。",
        "zh-Hans": "更改自动生成的 `v-tabs-slider` 的背景颜色"
      }
    },
    {
      "name": "slider-size",
      "type": [
        "number",
        "string"
      ],
      "default": 2,
      "source": "v-tabs",
      "description": {
        "en": "Changes the size of the slider, **height** for horizontal, **width** for vertical.",
        "ja": "スライダーのサイズを変更します。**height**は水平用、**width**は垂直用です。",
        "zh-Hans": "更改滑块的大小，水平 **height**，垂直 **width**。"
      }
    },
    {
      "name": "value",
      "type": "any",
      "default": "undefined",
      "source": "proxyable",
      "description": {
        "en": "The designated model value for the component.",
        "ja": "コンポーネントの指定されたモデルの値。",
        "zh-Hans": "组件的指定 model 值。"
      }
    },
    {
      "name": "vertical",
      "type": "boolean",
      "default": "false",
      "source": "v-tabs",
      "description": {
        "en": "Stacks tabs on top of each other vertically.",
        "ja": "タブを垂直方向（縦）に並べます。",
        "zh-Hans": "垂直堆叠选项卡。"
      }
    }
  ],
  "mixins": [
    "colorable",
    "proxyable",
    "themeable"
  ],
  "slots": [
    {
      "name": "default",
      "description": {
        "en": "The default Vue slot.",
        "ja": "デフォルトの Vue slot",
        "zh-Hans": "默认Vue 插槽。"
      }
    }
  ],
  "events": [
    {
      "name": "change",
      "value": "number | string",
      "description": {
        "en": "Emitted when tab is changed by user interaction. Returns a string if **href** attribute is set and number if it is not.",
        "ja": "ユーザの操作によってタブが変更されたときに発生します。**href** 属性が設定されている場合は文字列を返し、そうでない場合は数値を返します。",
        "zh-Hans": "Emitted when tab is changed by user interaction. Returns a string if **href** attribute is set and number if it is not."
      }
    }
  ],
  "functions": [],
  "name": "v-tabs",
  "sass": [
    {
      "name": "$tab-disabled-opacity",
      "default": ".5 !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tab-font-size",
      "default": "map-deep-get($headings, 'subtitle-2', 'size') !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tab-font-weight",
      "default": "map-deep-get($headings, 'subtitle-2', 'weight') !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tab-text-transform",
      "default": "uppercase !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tab-line-height",
      "default": "normal !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-bar-background-color",
      "default": "'cards' !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-bar-height",
      "default": "48px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-icons-and-text-bar-height",
      "default": "72px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-icons-and-text-first-tab-margin-bottom",
      "default": "6px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-item-align-with-title-margin",
      "default": "42px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-item-letter-spacing",
      "default": ".0892857143em !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-item-max-width",
      "default": "360px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-item-min-width",
      "default": "90px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-item-padding",
      "default": "0 16px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-item-vertical-height",
      "default": "$tabs-bar-height !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$tabs-item-vertical-icons-and-text-height",
      "default": "$tabs-icons-and-text-bar-height !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    }
  ],
  "component": true
}